var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRulesManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "-4 -3 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 0.25H11.75V3C11.75 3.9665 10.9665 4.75 10 4.75H6C5.0335 4.75 4.25 3.9665 4.25 3V0.25ZM5.75 1.75V3C5.75 3.13807 5.86193 3.25 6 3.25H10C10.1381 3.25 10.25 3.13807 10.25 3V1.75H5.75ZM2 2.75C1.86193 2.75 1.75 2.86193 1.75 3V16C1.75 16.1381 1.86193 16.25 2 16.25H14C14.1381 16.25 14.25 16.1381 14.25 16V3C14.25 2.86193 14.1381 2.75 14 2.75H12.75V1.25H14C14.9665 1.25 15.75 2.0335 15.75 3V16C15.75 16.9665 14.9665 17.75 14 17.75H2C1.0335 17.75 0.25 16.9665 0.25 16V3C0.25 2.0335 1.0335 1.25 2 1.25H3.25V2.75H2ZM4.25 7.5C4.25 7.08579 4.58579 6.75 5 6.75H11C11.4142 6.75 11.75 7.08579 11.75 7.5C11.75 7.91421 11.4142 8.25 11 8.25H5C4.58579 8.25 4.25 7.91421 4.25 7.5ZM4.25 10.5C4.25 10.0858 4.58579 9.75 5 9.75H9C9.41421 9.75 9.75 10.0858 9.75 10.5C9.75 10.9142 9.41421 11.25 9 11.25H5C4.58579 11.25 4.25 10.9142 4.25 10.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRulesManagement);
export default __webpack_public_path__ + "static/media/rules-management.f37f409e.svg";
export { ForwardRef as ReactComponent };